import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import Logo from "./Logo";
import { COMPANY, NAV_LINKS } from "../lib/siteData";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1D20] text-[#FCFCFA] pt-24 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 md:gap-8 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <Logo size={44} variant="light" />
            <p className="mt-8 text-[15px] leading-relaxed text-white/70 max-w-md">
              {COMPANY.name} — the master developer behind the Cape Maclear
              Special Economic Zone. A USD 3.5 billion vision for an
              integrated, sustainable African city on the shores of Lake
              Malawi.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-6">Explore</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  {l.external ? (
                    <a
                      href={l.to}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[14px] text-white/80 hover:text-[#D4AF37] transition-colors"
                      data-testid={`footer-${l.testid}`}
                    >
                      {l.label}
                    </a>
                  ) : (
                    <Link
                      to={l.to}
                      className="text-[14px] text-white/80 hover:text-[#D4AF37] transition-colors"
                      data-testid={`footer-${l.testid}`}
                    >
                      {l.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline mb-6">Head Office</p>
            <ul className="space-y-4 text-[14px] text-white/80">
              <li className="flex gap-3">
                <MapPin size={16} strokeWidth={1.5} className="text-[#D4AF37] mt-1 shrink-0" />
                <span>{COMPANY.address}</span>
              </li>
              <li className="flex gap-3">
                <Phone size={16} strokeWidth={1.5} className="text-[#D4AF37] mt-1 shrink-0" />
                <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="hover:text-[#D4AF37]">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex gap-3">
                <Mail size={16} strokeWidth={1.5} className="text-[#D4AF37] mt-1 shrink-0" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-[#D4AF37]">
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pt-8">
          <p className="text-[12px] uppercase tracking-[0.2em] text-white/50">
            © {new Date().getFullYear()} Cape Maclear Holdings Ltd. All rights reserved.
          </p>
          <p className="text-[12px] uppercase tracking-[0.2em] text-white/50">
            Registered in Malawi · {COMPANY.website}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
